import React from 'react';
import { UiView, UiViewContent } from "../../../library/layout/Index";
import InvImportItemsRow from './InvImportItemsRow'

const InvImportItems = (props) => {
    const { formObject, viewData, rowSelector } = props;


    const generateImportRows = () => {
        // console.log("import",viewData)
        if (viewData)
            return (
                Object.values(viewData).map((row, index) => (
                    <InvImportItemsRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} />
                ))
            )
    }

    return (
        <UiView>
            <UiViewContent>
                <div className="uiImportItemsList">
                    {generateImportRows()}
                </div>
            </UiViewContent>
        </UiView>
    )
}

export default InvImportItems
